export default {
  data() {
    return {
      emailReminderOptOutModal: false,
    };
  },
  watch: {
    emailReminderOptOutModal(value) {
      if (value) {
        this.analytics.click.emailOptOutModalOpen();
      } else {
        this.analytics.click.emailOptOutModalClose();
      }
    },
  },
  methods: {
    emailReminderOptOut() {
      this.emailReminderOptOutModal = true;
      this.$coa.emailReminderOptOut();
    },
  },
};
